import React, { Component } from 'react';
import profileImage from './Profile.jpg';
import './Header.less';

import TwitterIcon from 'react-icons/lib/fa/twitter';
import GitHubIcon from 'react-icons/lib/fa/github';
import LinkedInIcon from 'react-icons/lib/fa/linkedin';

class Header extends Component {
  render() {
    return (
        <header className="header">
            <a href="./">
                <img src={profileImage} className="profile-image" alt="profile" />
            </a>
            <div className="header-content">
                <a href="./"><h1 className="header-title">Nick Funk</h1></a>
                <div className="header-link">
                    <TwitterIcon></TwitterIcon>
                    <a href="https://twitter.com/softfalcon">@softfalcon</a>
                </div>
                <div className="header-link">
                    <GitHubIcon></GitHubIcon>
                    <a href="https://github.com/nick-funk">nick-funk</a>
                </div>
                <div className="header-link">
                    <LinkedInIcon></LinkedInIcon>
                    <a href="https://www.linkedin.com/in/nick-funk/">nick-funk</a>
                </div>
            </div>
        </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Header/Header.js